import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import firebase from '../../utils/firebase';
import {browserHistory, Link, hashHistory} from 'react-router';
import { fetchUser, updateUser } from '../../actions/firebase_actions';
import {updateModal} from '../../actions/modal';
import ResetPassword from '../reset_password/';
class UserProfile extends Component {

    constructor(props) {
        super(props);
        this.props.fetchUser();
        this.state = {
            message: '',
        };
        this.onFormSubmit = this.onFormSubmit.bind(this);
          this.resetPassword = this.resetPassword.bind(this);
    }



      resetPassword(){
        this.props.updateModal(true,<ResetPassword/>);
      }

    onFormSubmit(event) {
        event.preventDefault();
        const email = this.refs.email.value;
        const displayName = this.refs.displayName.value;
        this.props.updateUser({ email, displayName }).then((data) => {
            if (data.payload.errorCode) {
                this.setState({ message: data.payload.errorMessage });
            } else {
                /*this.setState({
                    message: 'Updated successfuly!',
                });*/
                this.props.updateModal(false,null);
            }
        }
    );
    }

    render() {
        return (
            <div>
                <form id="frmProfile" role="form" onSubmit={this.onFormSubmit}>
                    <span className="headerText">Profile</span><br/>
                      <p className="titleText">
                        {this.state.message}
                      </p>
                    <br />
                    <div className="form-group">
                      {/*    <label htmlFor="email"  className="titleText">Email</label>*/}
                        <input
                          type="text" disabled={true} defaultValue={this.props.currentUser.email}
                          className="form-control inputText" id="email" ref="email" placeholder="Email" name="email"/>
                    </div>
                   <div className="form-group">
                        <label htmlFor="displayName" className="titleText">Gaming Handle</label>
                        <input
                          type="text" maxLength="20" defaultValue={this.props.currentUser.displayName}
                          className="form-control inputText" ref="displayName" id="displayName" placeholder="Gaming Handle"
                          name="displayName"
                        />
                    </div>
                    <button type="submit" className="buttonStyle">Update</button>
                </form>
                <br/>
                {/*}<Link className="linkText" onClick={this.resetPassword}>Reset password?</Link>*/}
                <br/><br/>
                  <label htmlFor="displayName" className="headerText">More features coming soon!</label>
            </div>
        );
    }

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({ fetchUser, updateUser, updateModal }, dispatch);
}


function mapStateToProps(state) {
    return { currentUser: state.currentUser };
}


export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);



// WEBPACK FOOTER //
// ./src/app/components/profile/index.jsx